import { api } from '../../core/api.js';

export function getProduct(id) {
  return api(`/products/${encodeURIComponent(id)}`);
}

export function updateProduct(id, body) {
  return api(`/products/${encodeURIComponent(id)}`, { method: 'PUT', body });
}

export function archiveProduct(id) {
  return api(`/products/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function restoreProduct(id) {
  return api(`/products/${encodeURIComponent(id)}/restore`, { method: 'POST', body: {} });
}

/** Lightweight doc count for the overview - capped search, same as classic. */
export function countDocuments(productId) {
  return api(`/search?type=doc&limit=50&product_id=${encodeURIComponent(productId)}`);
}
